module.exports = __webpack_public_path__ + "static/media/tron_5.4793d7ad.jpg";